import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { isPersonTravellingWith } from '../../../../../utilities/pages';
import { useTranslation } from "react-i18next";

function VisaPrepFamilyStep2(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.FATHERS_PERSONAL_DETAILS}
        label={t('forms.visa:doYouHaveYourFatherSPersonalDeta')}
        value={boolToYesNo(props.hasFathersPersonalDetails)}
      />
      {props.hasFathersPersonalDetails === true ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_NATIONALITY}
            value={props.fatherNationality}
            label={t('forms.visa:fatherSNationality')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_SAME_NATIONALITY}
            label={t('forms.visa:haveTheyAlwaysHadTheSameNational')}
            value={boolToYesNo(props.fatherSameNationality)}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_FAMILY_NAME}
            value={props.fatherFamilyName}
            label={t('forms.visa:fatherSFamilyName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_GIVEN_NAME}
            value={props.fatherGivenName}
            label={t('forms.visa:fatherSGivenName')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_DOB}
            label={t('forms.visa:fatherSDateOfBirth')}
            value={props.fatherDob}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_PLACE_OF_BIRTH}
            value={props.fatherPlaceOfBirth}
            label={t('forms.visa:fatherSPlaceOfBirth')}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.FATHER_TRAVELLING_WITH}
            label={t('forms.visa:isThisPersonTravellingWithYou')}
            value={props.fatherTravellingWith}
          />
          {isPersonTravellingWith(props.fatherTravellingWith) ? (
            <>
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FATHER_UK_VISA}
                label={t('forms.visa:doTheyHaveAVisaForTheUk')}
                value={props.fatherUkVisa}
              />
              <SummaryRow
                className={'visa-summary'}
                key={VQ.FATHER_HAS_PASSPORT}
                label={t('forms.visa:doTheyHaveAPassportOrTravelDocum')}
                value={boolToYesNo(props.fatherHasPassport)}
              />
              {props.fatherHasPassport ? (
                <SummaryRow
                  className={'visa-summary'}
                  key={VQ.FATHER_PASSPORT_NUMBER}
                  value={props.fatherPassportNumber}
                  label={t('forms.visa:currentPassportOrTravelDocumentN')}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : null}
    </>
  );
}

export default VisaPrepFamilyStep2;
